<template src="./template.html" ></template>

<script>
// import MyAlert from '../../components/alert/MyAlert.vue'
import MyListButtons from '../add/Buttons.vue'
export default {
  name: 'bank-items',
  props: ['formTitle'],
  data() {
    return {
      validation: false,
      showAlert: false,
      model: {},
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
    }
  },
  methods: {
    async onSave() {
      // console.log(model);
      let _method = 'POST'
      if (this.formState === 'edit') {
        _method = 'PUT'
      }
      this.$refs.form.validate()
      let _data = {
        method: _method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        },
      }
      // console.log(_data);
      if (this.validation) {
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData
        if (res?.insert || res?.update) this.showAlert = true
      }
    },
  },
  // mounted() {
  //   this.$refs.title.focus()
  // },
  components: {
    // MyAlert,
    MyListButtons
  },
}
</script>
